export const packageSearchTypes = [
  {
    slug: "phone",
    name: "Утасны дугаар",
    length: 8,
  },
  {
    slug: "code",
    name: "Дайврын код",
    length: 6,
  },
  {
    slug: "driver",
    name: "Жолоочийн утас",
    length: 8,
  },
  {
    slug: "car",
    name: "Машины дугаар",
    length: 7,
  },
];

export const driverSearchTypes = [
  {
    slug: "phone",
    name: "Жолоочийн утас",
    length: 8,
  },
  {
    slug: "car",
    name: "Машины дугаар",
    length: 7,
  },
];
